module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./MemCardMsgView.js"));
	}, "MemCardMsgView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MemCardMsgView!./src/pages/Register/MemCardMsg/MemCardMsgView.js
// module id = 812
// module chunks = 438